export type Purchase = {
  name: string
  city: string
  state: string
}

/**
 * SAMPLE DATA. Only switch the notifications on (ENABLED in
 * PurchaseNotifications.tsx) once this list comes from real orders.
 */
export const recentPurchases: Purchase[] = [
  { name: 'Ashley M.', city: 'Austin', state: 'Texas' },
  { name: 'Chloe B.', city: 'Leeds', state: 'UK' },
  { name: 'Jessica R.', city: 'Denver', state: 'Colorado' },
  { name: 'Emily T.', city: 'Calgary', state: 'Alberta' },
  { name: 'Danielle P.', city: 'Scottsdale', state: 'Arizona' },
  { name: 'Sophie W.', city: 'Perth', state: 'WA' },
  { name: 'Lauren B.', city: 'Atlanta', state: 'Georgia' },
  { name: 'Hannah K.', city: 'Bristol', state: 'UK' },
  { name: 'Amanda G.', city: 'Minneapolis', state: 'Minnesota' },
  { name: 'Olivia D.', city: 'Ottawa', state: 'Ontario' },
  { name: 'Tiffany H.', city: 'St. Louis', state: 'Missouri' },
  { name: 'Grace L.', city: 'Melbourne', state: 'VIC' },
]
